module.exports = __webpack_public_path__ + "static/media/AM.6fa300ac.jpg";